module.exports = __webpack_public_path__ + "img/banner2.ba1c4026.jpg";